// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RQj1t","controls":"styles_controls__2Q4d4","charLimit":"styles_charLimit__2uTdO","input":"styles_input__3Ltcz","send":"styles_send__3_U4P"};